import { dareEndpointIds } from 'root/src/shared/dares/dares.constants';
import { authenticationTypes } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { project } from 'root/src/shared/descriptions/endpoints/recordTypes';
import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { CreatorEventFulfilledDareStatus } from 'root/src/shared/dares/creatorEventFulfilledDare.types';
export const getAdminCreatorEventFulfilledDaresEndpoint = {
    [dareEndpointIds.GET_ADMIN_CREATOR_EVENT_FULFILLED_DARES]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: AuthGroup.Admin,
        endpointType: otherEndpointType,
        recordType: project,
        payloadSchema: {
            type: 'object',
            properties: {
                status: {
                    type: 'string',
                    enum: Object.values(CreatorEventFulfilledDareStatus),
                },
            },
            required: ['status'],
        },
    },
};
